module.exports = __webpack_public_path__ + "img/gov2.0a4880b9.png";